import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { ThankyouScreenComponent } from './components/thankyou-screen/thankyou-screen.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule)
  },
  {
    path: '',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)  
  },
  {
    path: '',
    loadChildren: () => import('./admintabs/admintabs.module').then( m => m.AdmintabsPageModule)  
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)  
  },
  // {
  //   path: 'login/admin',
  //   loadChildren: () => import('./pages/admin/admin.module').then( m => m.AdminPageModule)
  // },
  {
    path: 'setup-account',
    loadChildren: () => import('./pages/setup-account/setup-account.module').then( m => m.SetupAccountPageModule)
  },
  {
    path: 'login/admin',
    loadChildren: () => import('./pages/admin-login/admin-login.module').then( m => m.AdminLoginPageModule)
  },
  {
    path: 'thanks',
    component: ThankyouScreenComponent
  },
  // {
  //   path: 'reports',
  //   component: ReportsComponent
  // },
  // {
  //   path: 'graphs',
  //   component: GraphsComponent
  // },
  {
    path: '**',
    component: PageNotFoundComponent
  },
  {
    path: 'admintabs',
    loadChildren: () => import('./admintabs/admintabs.module').then( m => m.AdmintabsPageModule)
  },

  {
    path: 'dashboard-graph',
    loadChildren: () => import('./pages/dashboard-graph/dashboard-graph.module').then( m => m.DashboardGraphPageModule)
  },

];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
